export const ONE_SECOND_IN_MS = 1000;
export const FIVE_SECONDS_IN_MS = 5 * ONE_SECOND_IN_MS;

export const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS;

export const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;
export const ONE_HOUR_IN_SECONDS = 60 * 60 * ONE_SECOND_IN_MS;
